import React from 'react';
import {inject, observer} from 'mobx-react';
import PropTypes from 'prop-types';

import {withI18n} from 'spa/Components/Context';

import CalendarCheckmark, {IconColorThemes} from '@urbanmassage/component-library/lib/Icons/CalendarCheckmark/CalendarCheckmark';
import { IconSizes } from '@urbanmassage/component-library/lib/Theme/b2c-theme';
import Certified from '@urbanmassage/component-library/lib/Icons/Certified/Certified';
import ContentBox, { ContentBoxColorThemes } from '@urbanmassage/component-library/lib/ContentBox/ContentBox';
import Circles from '@urbanmassage/component-library/lib/Icons/Circles/Circles';
import Comment from '@urbanmassage/component-library/lib/Icons/Comment/Comment';
import Star from '@urbanmassage/component-library/lib/Icons/Star/Star';

import './therapist-facts-grid.less';

@inject(({
  store: {
    screen,
  },
  therapistsState,
}) => ({
  screen,
  therapistsState,
}))
@observer
@withI18n
class TherapistFactsGrid extends React.Component {
  static propTypes = {
    iconSize: IconSizes.isRequired,
    screen: PropTypes.shape({
      isDesktop: PropTypes.bool,
    }).isRequired,
    therapistsState: PropTypes.shape({
      numberOfBookings: PropTypes.number.isRequired,
      workerExperience: PropTypes.string.isRequired,
      workerLanguagesInfo: PropTypes.string,
      workerRating: PropTypes.string,
      totalReviews: PropTypes.number.isRequired,
    }).isRequired,
  }

  render() {
    const {
      iconSize,
      screen: {isDesktop},
      therapistsState: {
        numberOfBookings,
        workerExperience,
        workerLanguagesInfo,
        workerRating,
        totalReviews,
      },
    } = this.props;
    const {i18n} = this.context;

    return (
      <React.Fragment>
        <div className="therapist-facts-grid__facts-container">
          <ContentBox
            className="therapist-facts-grid__facts-item"
            icon={<CalendarCheckmark color={IconColorThemes.uiDark1} size={iconSize} />}
            stackedBreakpoint="800px"
            title={i18n._x('Number of bookings', 'Therapist details page')}
            textContent={numberOfBookings}
          />
          <ContentBox
            className="therapist-facts-grid__facts-item"
            icon={<Comment color={IconColorThemes.uiDark1} size={iconSize} />}
            stackedBreakpoint="800px"
            title={i18n._x('Languages', 'Therapist single page')}
            textContent={workerLanguagesInfo}
          />
        </div>
        <div className="therapist-facts-grid__facts-container">
          <ContentBox
            className="therapist-facts-grid__facts-item"
            icon={<Circles color={IconColorThemes.uiDark1} size={iconSize} />}
            stackedBreakpoint="800px"
            title={i18n._x('Experience', 'Therapist single page')}
            textContent={workerExperience}
          />
          <ContentBox
            className="therapist-facts-grid__facts-item"
            icon={<Star
              color={IconColorThemes.uiDark1}
              outlineOnly
              size={iconSize}
            />}
            stackedBreakpoint="800px"
            title={i18n._x('Rated %(workerRating)s', 'Therapist single page', {
              workerRating,
            })}
            textContent={i18n._x('%(totalReviews)s Reviews', 'Therapist single page', {
              totalReviews,
            })}
          />
          {!isDesktop && (
            <ContentBox
              className="therapist-facts-grid__facts-item"
              hideTextBorderMobile
              icon={<Certified color={IconColorThemes.uiDark1} size={iconSize} />}
              stackedBreakpoint="800px"
              textContent={i18n._x('Fully insured and certified', 'Therapist details page')}
              theme={ContentBoxColorThemes.white}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}

export default TherapistFactsGrid;



// WEBPACK FOOTER //
// ./spa/Pages/Therapists/TherapistFactsGrid.jsx